import React, { Component, useEffect, useState } from "react";
import { postData, getData, patchData, deleteData } from "../../util/Fetch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { format, subDays } from "date-fns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import zhTW from "date-fns/locale/zh-TW";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const Salary = () => {
  const [salary, setSalarys] = useState([]);
  const [selectedFromDate, setSelectedFromDate] = useState(
    subDays(new Date(), 365)
  );
  const [selectedToDate, setSelectedToDate] = useState(new Date());

  useEffect(() => {
    getData("Salary", {}).then((res) => {
      setSalarys(res);
    });
  }, []);

  const handleFromDateChange = (date) => {
    setSelectedFromDate(date);
  };

  const handleToDateChange = (date) => {
    setSelectedToDate(date);
  };

  const handleSearch = () => {
    postData("Salary", {
      fromDate: selectedFromDate,
      toDate: selectedToDate,
    }).then((res) => {
      setSalarys(res);
    });
  };

  const tableCellStyle = {
    borderBottom: "", // 默认边框为下边框
  };

  const lastCellBorderStyle = {
    borderBottom: "none", // 最后一个单元格的下边框
  };

  return (
    <div>
      <div>
        <LocalizationProvider adapterLocale={zhTW} dateAdapter={AdapterDateFns}>
          <DatePicker
            label="開始日期"
            value={selectedFromDate}
            onChange={handleFromDateChange}
            inputFormat={"yyyy/MM/dd"}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        <LocalizationProvider adapterLocale={zhTW} dateAdapter={AdapterDateFns}>
          <DatePicker
            label="結束日期"
            value={selectedToDate}
            onChange={handleToDateChange}
            inputFormat={"yyyy/MM/dd"}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        <Button
          variant="contained"
          onClick={handleSearch}
          sx={{ height: "56px" }}
        >
          查詢
        </Button>
      </div>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>發薪日</TableCell>
              <TableCell align="right">技術業績</TableCell>
              <TableCell align="right">店販業績</TableCell>
              <TableCell align="right">補充事項</TableCell>
              <TableCell align="right">薪資</TableCell>
              <TableCell align="right">備註</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {salary.map((salary, index) => (
              <TableRow
                key={`${salary.payDate}`} // Unique key for each row
              >
                <TableCell>
                  {format(new Date(salary.payDate), "yyyy-MM-dd")}
                </TableCell>
                <TableCell align="right">{salary.skillIncome}</TableCell>
                <TableCell align="right">{salary.shopIncome}</TableCell>
                <TableCell align="right">
                  {salary.plusData.map((x, index) => (
                    <React.Fragment key={index}>
                      <br />
                      <a>{x}</a>
                    </React.Fragment>
                  ))}
                </TableCell>
                <TableCell align="right">{salary.salary}</TableCell>
                <TableCell align="right">{salary.note}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default Salary;
